export default __webpack_public_path__ + "assets/payment-and-discount.2a7c1fb2.svg";